export default "__VITE_ASSET__8LsteUx5__"